import { AccountEmployeeResolver } from '@account/account-employee.resolver';
import { AccountMenuService } from '@account/services';
import { Component, ElementRef, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    AbilityService,
    AnalyticService,
    AuthService,
    FileHelperService,
    NotifyService,
    PayrollService,
} from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { ChangeRequestTemplateDisplayOptions } from '@app/types/translatables/change-request-template-display.options';
import { EmploymentTypeDisplayOptions } from '@app/types/translatables/employment-type-display.options';
import { PaymentMethodDisplayOptions } from '@app/types/translatables/payment-method-display.options';
import { EmployeeChangeRequestTemplatesService } from '@employees/services';
import { JobAndPayShowView as EmployeeJobAndPayShowView } from '@employees/views';

@Component({
    templateUrl: './job-and-pay-show.template.html',
    styleUrls: ['./job-and-pay-show.style.scss'],
})
export class JobAndPayShowView extends EmployeeJobAndPayShowView {
    isSelfEmployeeView = true;
    employmentTypesDisplay = EmploymentTypeDisplayOptions;
    paymentMethodDisplay = PaymentMethodDisplayOptions;

    changeRequestTemplate = ChangeRequestTemplateDisplayOptions;
    constructor(
        public changeRequestTemplateService: EmployeeChangeRequestTemplatesService,
        protected abilities: AbilityService,
        protected element: ElementRef,
        protected route: ActivatedRoute,
        protected router: Router,
        protected auth: AuthService,
        protected file: FileHelperService,
        protected notify: NotifyService,
        protected injector: Injector,
        protected payrollService: PayrollService,
        public tabMenuService: AccountMenuService,
        protected analyticsService: AnalyticService,
        protected featureService: FeatureService
    ) {
        super(
            changeRequestTemplateService,
            abilities,
            element,
            route,
            router,
            auth,
            file,
            notify,
            injector,
            payrollService,
            analyticsService,
            featureService
        );
    }

    protected setResolver(): void {
        this.resolver = this.injector.get(AccountEmployeeResolver);
    }
}
